// extracted by mini-css-extract-plugin
export default {"form":"xbepc","okta":"yP0ZX","entra":"jimoV"};